import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Flex, Spacer } from '@chakra-ui/react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { CloseIcon } from '../../../images';
import { getSettingsForChat, setChatHidden } from '../../../redux/reducers';

const ChatTabs = ({ tabs, unseen, select, current }) => {
  const dispatch = useDispatch();
  const { color, bgColor, altBg } = useSelector(getSettingsForChat, shallowEqual);
  const closeChat = useCallback(() => {
    dispatch(setChatHidden(true));
  }, []);

  return (
    <Flex sx={{ fontWeight: 'bold', bg: altBg, flexShrink: 0 }}>
      {Object.entries(tabs).map(([tab, name]) =>
        tab === current ? (
          <Box key={tab} sx={{ color, bg: bgColor, height: '100%', px: 3, overflow: 'hidden' }}>
            <Box
              sx={{
                py: 2,
                px: 2,
                borderBottomWidth: 3,
                borderBottomColor: 'brand.50',
              }}
            >
              <Box maxHeight="100px">
                {name}
                {unseen[tab] ? ' *' : ''}
              </Box>
            </Box>
          </Box>
        ) : (
          <Box
            key={tab}
            sx={{
              color,
              bg: unseen[tab] ? 'brand.50' : altBg,
              height: '100%',
              px: 3,
              borderRightWidth: '1px',
              borderRightStyle: 'solid',
              borderRightColor: bgColor,
              overflow: 'hidden',
            }}
            onClick={() => select(tab)}
          >
            <Box sx={{ py: 2, px: 2 }}>
              <Box maxHeight="100px">
                {name} {unseen[tab] ? ' *' : ''}
              </Box>
            </Box>
          </Box>
        )
      )}
      <Spacer />
      <Button
        flex="0 0 43px"
        sx={{
          color,
          bg: altBg,
          height: '43px',
          p: 0,
          borderRadius: 0,
          borderLeftWidth: '1px',
          borderLeftStyle: 'solid',
          borderLeftColor: bgColor,
        }}
        onClick={closeChat}
      >
        <CloseIcon />
      </Button>
    </Flex>
  );
};

ChatTabs.propTypes = {
  tabs: PropTypes.object,
  unseen: PropTypes.object,
  select: PropTypes.func,
  current: PropTypes.string,
};

export default ChatTabs;
